import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../../utils/auth";
import { getPage } from "../../../utils/index";
import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import TopHeading from "../TopHeading";
import Empty from "../../common/Empty";
import moment from "moment";
import { Avatar, Button, Drawer, Modal } from "antd";
import { CheckOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import SettlementDetails from "./Details";
import { responseNotification } from "../../../utils/notify";

const MySettlementList = () => {
  const [limit, setLimit] = useState(16);

  const [selectedSettlement, setSelectedSettlement] = useState(undefined);

  const [transactionData, setTransactionData] = useState({
    loading: false,
    data: null,
  });

  const loc = useLocation();

  const getSettlements = useCallback(async () => {
    setTransactionData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(`${encodedUri}/admin/order/settlement-list`, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      })
      .then((res) => {
        setTransactionData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setTransactionData({ loading: false, data: [] });
        console.error("Drivers: Error", err);
      });
  }, []);

  const onApproveSettlement = async (settlementId) => {
    if (settlementId) {
      await fetch(
        `${process.env.REACT_APP_ORDER_API}/admin/order/settlement-approve/${selectedSettlement?.id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getSettlements();
            onClose();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const confirmSettlement = () => {
    Modal.confirm({
      title: "Do you confirm?",
      icon: <ExclamationCircleOutlined />,
      content: `Will you Receive BDT ${selectedSettlement?.amount} from ${selectedSettlement?.deliveryMan?.name}`,
      okText: "Received",
      cancelText: "Cancel",
      onOk: onApproveSettlement,
    });
  };

  // const getTransactionsOptions = useCallback(
  //   async (mobileNumber) => {
  //     setDriversOptions({ loading: true, list: null });
  //     const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
  //     axios
  //       .get(
  //         `${encodedUri}/admin/transaction?` +
  //           (mobileNumber
  //             ? `&mobile=%2B88${mobileNumber?.replace("+88", "")}`
  //             : ``) +
  //           (status ? `&status=${status}` : ``) +
  //           `&page=${0}` +
  //           `&limit=${20}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authenticateToken()}`,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         setDriversOptions({
  //           loading: false,
  //           list: res.data?.drivers?.map((transaction) => ({
  //             label: transaction.name,
  //             value: transaction.mobileNumber,
  //           })),
  //         });
  //       })
  //       .catch((err) => {
  //         setDriversOptions({ loading: false, list: [] });
  //         console.error("Drivers: Error", err);
  //       });
  //   },
  //   [status]
  // );

  useEffect(() => {
    getSettlements();
  }, [getSettlements]);

  const onClose = () => {
    setSelectedSettlement(null);
  };

  return (
    <React.Fragment>
      <TopHeading
        // total={transactionData?.data?.totalElements}
        title={`My Settlement List`}
        // refetch={getTransactions}
      />

      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Delivery Hero</span>
                  </div>
                  <div className="single-product-heading">
                    <span>DH Contact</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Date & Time</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Amount</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {transactionData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {transactionData?.data?.settlementRequests?.length ? (
                    transactionData?.data?.settlementRequests?.map(
                      (settlement, index) => (
                        <React.Fragment key={index}>
                          <div
                            className="single-product-wrapper"
                            onClick={() => setSelectedSettlement(settlement)}
                          >
                            {console.log("Data:", selectedSettlement)}
                            <div className="single-product">
                              <span className="name">
                                <Avatar
                                  src={settlement?.deliveryMan?.profilePicture}
                                  size={45}
                                />{" "}
                                {settlement?.deliveryMan?.name}
                              </span>
                            </div>

                            <div className="single-product">
                              <span className="name">
                                {settlement?.deliveryMan?.mobileNumber?.replace(
                                  "+88",
                                  ""
                                )}
                              </span>
                            </div>

                            <div className="single-product">
                              <span className="name text-capitalize">
                                {moment(settlement?.createdAt).format("lll")}
                              </span>
                            </div>

                            <div className="single-product">
                              <span className="name">
                                &#2547; {settlement?.amount}
                              </span>
                            </div>

                            <div className="single-product">
                              <span
                                className={`radius-btn ${settlement?.status?.toLowerCase()}-btn`}
                              >
                                {settlement?.status?.split("-").join(" ")}
                              </span>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Data" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title="Settlement Request Details"
            width={500}
            onClose={onClose}
            visible={selectedSettlement}
            extra={
              <Button
                type="dashed"
                shape="round"
                danger
                onClick={confirmSettlement}
              >
                <CheckOutlined /> APPROVE
              </Button>
            }
            footer={false}
          >
            <SettlementDetails
              settlementInfo={selectedSettlement}
              onCloseMethod={onClose}
              // refetch
            />
          </Drawer>

          <PaginationTwo
            {...transactionData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default MySettlementList;
